import { Controller } from "@hotwired/stimulus"

// Markdown editor with toolbar actions and keyboard shortcuts.
// Mount on a parent element; the actual <textarea> is a target.
export default class extends Controller {
  static targets = ["textarea"]

  connect() {
    this.textareaTarget.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    this.textareaTarget.removeEventListener("keydown", this.handleKeydown)
  }

  // --- Toolbar actions (called via data-action) ---

  heading() {
    const ta = this.textareaTarget
    const start = ta.selectionStart
    const lineStart = ta.value.lastIndexOf("\n", start - 1) + 1
    const prefix = "## "

    ta.setRangeText(prefix, lineStart, lineStart)
    ta.selectionStart = ta.selectionEnd = start + prefix.length
    ta.focus()
    this.dispatchChange()
  }

  bold() {
    this.wrapSelection("**", "**")
  }

  italic() {
    this.wrapSelection("_", "_")
  }

  code() {
    const ta = this.textareaTarget
    const selected = ta.value.substring(ta.selectionStart, ta.selectionEnd)
    if (selected.includes("\n")) {
      this.wrapSelection("```\n", "\n```")
    } else {
      this.wrapSelection("`", "`")
    }
  }

  link() {
    this.insertLink()
  }

  // --- Keyboard shortcuts ---

  handleKeydown = (event) => {
    if (!event.ctrlKey && !event.metaKey) return

    switch (event.key) {
      case "b":
        event.preventDefault()
        this.bold()
        break
      case "i":
        event.preventDefault()
        this.italic()
        break
      case "l":
        event.preventDefault()
        this.link()
        break
      case "`":
        event.preventDefault()
        this.code()
        break
    }
  }

  // --- Private helpers ---

  wrapSelection(before, after) {
    const ta = this.textareaTarget
    const start = ta.selectionStart
    const end = ta.selectionEnd
    const selected = ta.value.substring(start, end)

    ta.setRangeText(before + selected + after, start, end)
    ta.selectionStart = start + before.length
    ta.selectionEnd = end + before.length
    ta.focus()
    this.dispatchChange()
  }

  insertLink() {
    const ta = this.textareaTarget
    const start = ta.selectionStart
    const end = ta.selectionEnd
    const selected = ta.value.substring(start, end)

    if (selected) {
      const linkText = `[${selected}](url)`
      ta.setRangeText(linkText, start, end)
      ta.selectionStart = start + selected.length + 3
      ta.selectionEnd = start + selected.length + 6
    } else {
      const linkText = "[link text](url)"
      ta.setRangeText(linkText, start, end)
      ta.selectionStart = start + 1
      ta.selectionEnd = start + 10
    }
    ta.focus()
    this.dispatchChange()
  }

  dispatchChange() {
    this.textareaTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
